import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function hasNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return /[0-9]/.test(control.value)
      ? null
      : { hasNumberValidator: { value: control.value } };
  };
}
